import React from 'react';
import CSSclasses from './Backdrop.module.css' 

const backdrop = (props) => (
  props.show ? <div className={CSSclasses.Backdrop} onClick={props.clicked}></div> : null
); 

export default backdrop;
